module.exports = __webpack_public_path__ + "img/ic-pdf_doc_violet.151722d7.svg";